import { Column } from 'components/Blocks';

import { useAppWrapper } from '../WrapperContext';
import { SideLink } from './SideLink';

import { useLang } from 'locale';

export function SideBarContent() {
  const { t } = useLang();

  const { showMobileSidebar } = useAppWrapper();

  return (
    <Column gap="6" className="pt-6" alignItems={!showMobileSidebar ? 'center' : undefined}>
      <SideLink to="home" label={t('available-surveys')} icon="home" />

      <SideLink to="reward" label={t('rewards-and-redeem')} icon="trophy" />

      <SideLink to="account" label={t('manage-account')} icon="account" />
    </Column>
  );
}
